/* globals alert, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true, camelcase:false */
'use strict';

/*
    setHostContext sends:
    {
        "backToArticleUrl": "",
        "gaClientId": "UA-6354151-13",
        "measurementId": "G-8C9CXJB2M1",
        "host": "preview-mn.hb101.org",
        "JWT": "eyJ...V2o",
        "language": "en",
        "leaveOnLogout": false,
        "panel": false,
        "roles": [
            "rts-admin",
            "admin"
        ],
        "service": "https://staging.rts.hb101.org/places.htm",
        "stateCode": "MN",
        "target": "",
        "userName": "rts@suika.com"
    }

    calls to token return:
    {
        ".expires": "Thu, 22 Aug 2019 13:22:47 GMT",
        ".issued": "Wed, 21 Aug 2019 13:22:47 GMT",
        "access_token": "eyJ...MW0",
        "EmailConfirmed": "False",
        "expires_in": 86399,
        "Roles": "[\"rts-admin\",\"admin\"]",
        "stoken": "mLY...RLw==",
        "token_type": "bearer",
        "UserName": "rts@suika.com"
    }
*/

// script.src = src.replace('min', 'debug');

const Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    configuration = require('../utilities/configuration'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    inChannel = BackboneRadio.channel('vaultInterface:in'),
    outChannel = BackboneRadio.channel('vaultInterface:out'),
    guestContext = {
        userName: '',
        JWT: null,
        roles: ['_guest_']
    },
    User = Backbone.Model.extend({
        allCapabilities: function () {
            return ['administrator', 'organization', 'enrollee', 'guest'];
        },
        authorizationHeader: function (requestee) {
            return (this.attributes.JWT ? { 'Authorization': 'Bearer ' + this.attributes.JWT } : {});
        },
        hasCapability: function (capability) {
            let has = false;
            switch (capability) {
                case 'guest':
                    has = true;
                    break;
                case 'enrollee':
                    has = this.hasJwt();
                    break;
                case 'organization':
                    has = _.intersection(this.roles(), ['rts-org', 'rts-admin']).length > 0;
                    break;
                case 'administrator':
                    has = _.includes(this.roles(), 'rts-admin');
                    break;
                default:
                    break;
            }
            return has;
        },
        hasJwt: function () {
            return (!!this.attributes.JWT);
        },
        hasRole: function (role) {
            return _.includes(this.roles(), role);
        },
        highestCapability: function () {
            return _.find(this.allCapabilities(), _.bind(this.hasCapability, this));
        },
        initialize: function () {
            inChannel.on('setHostContext', _.bind(function (context) {
                this.set(context);
            }, this));
            inChannel.on('logon', function () {
                // on a fresh logon, ask host for context. Host will respond with setHostContext message.
                outChannel.trigger('requestHostContext', {});
            });
            inChannel.on('logout', _.bind(function () {
                this.signOut();
            }, this));
            this.signOut();
        },
        isSignedIn: function () {
            return this.hasJwt();
        },
        signIn: function (userName, password) {
            jQuery.ajax({
                    url: 'https://preview-mn.hb101.org/l2svc/Token',
                    method: 'POST',
                    data: {
                        grant_type: 'password',
                        username: userName, // rtse@suika.com, rtso@suika.com, rtsa@suika.com
                        password: password  // #GKUWtjyg530
                    }
                })
                .done(function (response) {
                    // @acavan! - do we need to provide defaults for other context properties?
                    const context = {
                            JWT: response.access_token,
                            userName: response.UserName,
                            roles: JSON.parse(response.Roles),
                            gaClientId: configuration.gaClientId,
                            measurementId: configuration.measurementId
                        };
                    inChannel.trigger('setHostContext', context);
                })
                .fail(function (response) {
                    alert('Status: ' + response.status + '\n' + JSON.stringify(response.responseJSON, null, 4));
                });
        },
        signOut: function () {
            inChannel.trigger('setHostContext', guestContext);
        },
        roles: function () {
            return this.attributes.roles || []; // mustn't be null.
        }
    }),
    EOL = null;

module.exports = new User();
